var cbs, noop;

noop = require("./_helpers").noop;

cbs = [];

window.onpopstate = function(e) {
  var cb, i, len, o, results;
  results = [];
  for (i = 0, len = cbs.length; i < len; i++) {
    o = cbs[i];
    results.push((function() {
      var j, len1, ref, results1;
      ref = o._cbs;
      results1 = [];
      for (j = 0, len1 = ref.length; j < len1; j++) {
        cb = ref[j];
        results1.push(cb.call(o["this"], e));
      }
      return results1;
    })());
  }
  return results;
};

module.exports = {
  _name: "@popstate",
  _v: 1,
  _evLookup: {
    popstate: function(o) {
      o["this"] = this;
      o.activate = function() {
        cbs.push(o);
        return function() {
          return cbs.splice(cbs.indexOf(o), 1);
        };
      };
      return o;
    }
  }
};



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/@popstate.js
// module id = 40
// module chunks = 1